<template>
  <div class="result" v-if="config.icon">
    <div>
      <a-icon class="icon" :style="{color: config.icon.color}" :type="config.icon.type" />
    </div>
    <div class="title">{{ config.label }}</div>
    <div class="description" v-html="config.description"></div>
    <div class="action">
      <a-button @click="() => { $router.push({name: 'login'}) }">去首页</a-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      success: {
        email: { label: '邮箱激活成功', description: '开启您的项目之旅吧' },
        wechat: { label: '微信绑定成功', description: '随时接收项目动态，不错过对接消息' }
      },
      fail: {
        email: { label: '邮箱激活失败', description: '您可能重复点击了激活链接，请确认是否已激活' },
        wechat: { label: '微信绑定失败', description: '请重试' }
      },
      state: {
        event: '', // 激活类型 email | wechat
        status: '' // 激活状态 success | fail
      }
    }
  },
  computed: {
    config () {
      const vm = this
      let icon, label, description
      switch (vm.state.status) {
        case 'success':
          label = vm.success[vm.state.event].label
          description = vm.success[vm.state.event].description
          icon = {
            color: '#52c41a',
            type: 'check-circle'
          }
          break
        case 'fail':
          label = vm.fail[vm.state.event].label
          description = vm.fail[vm.state.event].description
          icon = {
            color: '#ff424e',
            type: 'close-circle'
          }
          break
        default:
          vm.$router.replace({ name: 'login' })
          break
      }
      return {
        icon,
        label,
        description
      }
    }
  },
  created () {
    const vm = this
    const params = vm.$route.query
    vm.state.event = params.event
    vm.state.status = params.status
  },
  methods: {
    closeWindow () {
      window.close()
    }
  }
}
</script>

<style scoped lang="less">
.result {
  text-align: center;
  width: 80%;
  margin: 0 auto;
  padding: 24px 0 8px;

  .icon {
    font-size: 72px;
    line-height: 72px;
    margin-bottom: 24px;
  }
  .success {
    color: #52c41a;
  }
  .error {
    color: red;
  }
  .title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 16px;
  }
  .description {
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 24px;
  }

  .action {
    margin-top: 32px;
  }
}
</style>
